import { useEffect, useState } from 'react';
import useMedia from './use-media';
import Media, { MediaType, MediaEvents } from '../common/media';
import { VideoTexture, LinearFilter, RGBFormat, Texture } from 'three';

const useVideoTexture = (resourceUID?: string) => {
  const media = useMedia(resourceUID, MediaType.Video);

  const [data, setData] = useState<{
    texture: VideoTexture | Texture;
    media: Media | undefined;
    loaded: boolean;
  }>({
    texture: new Texture(),
    media,
    loaded: false,
  });

  useEffect(() => {
    let isMounted = true;

    if (data.media) {
      data.media.on(MediaEvents.Change_Resource, () => {
        if (isMounted) {
          setData(state => ({
            ...state,
            loaded: false,
          }));
        }
      });

      data.media.on(MediaEvents.Ready, () => {
        if (data.media) {
          const texture = new VideoTexture(data.media.element as HTMLVideoElement);
          texture.minFilter = LinearFilter;
          texture.magFilter = LinearFilter;
          texture.format = RGBFormat;

          setTimeout(() => {
            if (isMounted) {
              setData(state => ({
                ...state,
                loaded: true,
                texture,
                media: data.media,
              }));
            }
          }, 2000);
        }
      });
    }

    return () => {
      isMounted = false;
      // Media.destroyMedia(data.media);
    };
  }, [data.media]);

  return data;
};

export default useVideoTexture;
